import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a0e074e2ab6ae0014b9dc96_1783184632791_49e82b93/mytrading/src/app/sign-up-login-screen/components/AuthForm.tsx");
